import React from 'react';
import ObjectBrowserWidget from '@plone/volto/components/manage/Widgets/ObjectBrowserWidget';

import './redirect-block.less';

const Edit = ({ data, block, onChangeBlock, selected }) => {
  return (
    <div
      className={`redirect-block redirect-block--edit${selected ? ' redirect-block--selected' : ''}`}
    >
      <div className="redirect-block__body">
        <span className="redirect-block__label">Redirect visitors to</span>

        <ObjectBrowserWidget
          id={`redirect-url-${block}`}
          title="Redirect URL"
          mode="link"
          allowExternals
          value={data.url || []}
          onChange={(id, value) => onChangeBlock(block, { ...data, url: value })}
        />

        <p className="redirect-block__help">
          Visitors will be redirected automatically. Editors are not redirected.
        </p>
      </div>
    </div>
  );
};

export default Edit;
